import { TrackingDataProps } from '../../../../../../common/AnalyticsContext/LinkTracking';
import { BookingBar, Maybe } from '../../../../../../common/schema/hannibal/types.generated';
import { SearchResultAppointmentSummary } from '../../../../../types';
import { AppointmentSelector } from './AppointmentSelector';
import { BookNow } from './BookNow';
import { DownloadApp } from './DownloadApp';

export interface Props extends TrackingDataProps {
  appointmentSummary: SearchResultAppointmentSummary | null;
  barType?: BookingBar;
  id: string;
  isTelehealthOnly?: boolean;
  name: string;
  phone?: Maybe<string>;
  profileUrl: string;
  searchSpecialty: string;
  type: 'practice' | 'practitioner';
  timezone?: string;
}

export const Appointments = ({
  appointmentSummary,
  barType,
  id,
  name,
  profileUrl,
  searchSpecialty,
  trackingData,
  isTelehealthOnly,
  type,
  timezone,
}: Props) => (
  <>
    {barType === BookingBar.Appointments && (
      <AppointmentSelector
        appointmentSummary={appointmentSummary}
        id={id}
        isTelehealthOnly={isTelehealthOnly}
        name={name}
        profileUrl={profileUrl}
        specialty={searchSpecialty}
        trackingData={trackingData}
        type={type}
        timezone={timezone}
      />
    )}

    {barType === BookingBar.BookNow && (
      <BookNow trackingData={trackingData} practiceId={id} specialty={searchSpecialty} />
    )}

    {barType === BookingBar.App && <DownloadApp id={id} type={type} trackingData={trackingData} />}
  </>
);
